module.exports = __webpack_public_path__ + "static/img/slogan.e33a548.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sy/slogan.svg
// module id = 7UJk
// module chunks = 182